import { actionTypes, eventNames } from 'app/constants/AnalyticsGa4Constants';
import AuthConstants from 'app/constants/AuthConstants';
import CheckoutConstants from 'app/constants/CheckoutConstants';
import HoldsConstants from 'app/constants/HoldsConstants';
import {
  selectBibEntity,
  selectOrganizationEntity,
  selectProductEntity,
  selectUserEntity
} from 'app/selectors/AnalyticsGa4Selector';

const DATA_LAYER_NAME = 'dataLayer';

const pushEvent = (name, entities = {}, properties = undefined) => {
  const event = {
    event: name,
    entities: {
      bib: entities.bib ?? undefined,
      event: entities.event ?? undefined,
      list: entities.list ?? undefined,
      organization: entities.organization ?? undefined,
      product: entities.product ?? undefined,
      ui: entities.ui ?? undefined,
      user: entities.user ?? undefined
    },
    event_properties: properties
  };

  (window[DATA_LAYER_NAME] || (window[DATA_LAYER_NAME] = [])).push(event);
};

export default function AnalyticsGa4Middleware() {
  return ({ getState }) => next => action => {
    if (__SERVER__) {
      return next(action);
    }

    const result = next(action);
    const { type } = action;
    const state = getState();

    switch (type) {
      case AuthConstants.AUTH_LOGIN_SUCCESS: {
        const entities = {
          organization: selectOrganizationEntity(state).toJS(),
          product: selectProductEntity(state).toJS(),
          user: selectUserEntity(state)?.toJS()
        };

        pushEvent(eventNames.USER_LOG_IN, entities);
        break;
      }

      case CheckoutConstants.DIGITAL_CHECKOUT_SUCCESS: {
        const entities = {
          bib: selectBibEntity(state, action.payload.id)?.toJS(),
          organization: selectOrganizationEntity(state).toJS(),
          product: selectProductEntity(state).toJS(),
          user: selectUserEntity(state)?.toJS()
        };

        pushEvent(eventNames.CHECKOUT_PLACE, entities);
        break;
      }

      case actionTypes.TRACK_SDK_CHECKOUT_PLACE: {
        const entities = {
          bib: action.payload.bib,
          organization: selectOrganizationEntity(state).toJS(),
          product: selectProductEntity(state).toJS(),
          user: selectUserEntity(state)?.toJS() ?? undefined
        };

        pushEvent(eventNames.CHECKOUT_PLACE, entities);
        break;
      }

      case actionTypes.TRACK_SDK_HOLD_PLACE: {
        const entities = {
          bib: action.payload.bib,
          organization: selectOrganizationEntity(state).toJS(),
          product: selectProductEntity(state).toJS(),
          user: selectUserEntity(state)?.toJS()
        };

        pushEvent(eventNames.HOLD_PLACE, entities);
        break;
      }

      case actionTypes.TRACK_SDK_LOG_IN: {
        const entities = {
          organization: selectOrganizationEntity(state).toJS(),
          product: selectProductEntity(state).toJS(),
          user: action.payload?.user ?? selectUserEntity(state)?.toJS()
        };

        pushEvent(eventNames.USER_LOG_IN, entities);
        break;
      }

      case actionTypes.TRACK_SDK_USER_ACCOUNT_REGISTER: {
        const entities = {
          organization: selectOrganizationEntity(state).toJS(),
          product: selectProductEntity(state).toJS(),
          user: selectUserEntity(state)?.toJS()
        };

        pushEvent(eventNames.USER_ACCOUNT_REGISTER, entities);
        break;
      }

      case HoldsConstants.PLACE_HOLD_SUCCESS: {
        const entities = {
          bib: selectBibEntity(state, action.payload.id)?.toJS(),
          organization: selectOrganizationEntity(state).toJS(),
          product: selectProductEntity(state).toJS(),
          user: selectUserEntity(state)?.toJS()
        };

        pushEvent(eventNames.HOLD_PLACE, entities);
        break;
      }

      case actionTypes.TRACK_PAGE_VIEW: {
        const entities = {
          bib: selectBibEntity(state, action.payload?.bibId)?.toJS(),
          list: action.payload?.list,
          organization: selectOrganizationEntity(state).toJS(),
          product: selectProductEntity(state).toJS(),
          user: selectUserEntity(state)?.toJS()
        };

        pushEvent(eventNames.PAGE_VIEW, entities);
        break;
      }

      case actionTypes.TRACK_CONTENT_CLICK: {
        const entities = {
          event: action.payload?.event,
          ui: action.payload?.ui,
          organization: selectOrganizationEntity(state).toJS(),
          product: selectProductEntity(state).toJS(),
          user: selectUserEntity(state)?.toJS()
        };

        pushEvent(eventNames.CONTENT_CLICK, entities);
        break;
      }

      default: {
        break;
      }
    }

    return result;
  };
}
